module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div class='new-project-header'>\n  <h5>\n    Import from existing\n    <var>Behance</var>\n    portfolio.\n  </h5>\n</div>\n<form class='new-project-form' accept-charset='UTF-8' action='/portfolio/projects/search' data-validation='structured'>\n  <input name='service' value='behance' type='hidden'>\n  <div class='row'>\n    <label class='required' for='username'>\n      Enter your\n      <var>Behance</var>\n      username\n    </label>\n    <div class='interaction js-username-interaction'>\n      <input class='field full required' name='username' value='" + ($e($c(this.username))) + "' placeholder='Username' type='text' required data-parsley-error-message='Please provide a valid <var>Behance</var> username'>\n    </div>\n  </div>\n  <div class='actions row'>\n    <a class='button js-new-cancel medium transparent' href='javascript:;'>Cancel</a>\n    <input class='button js-new-project-submit medium primary' name='commit' type='submit' value='Import'>\n  </div>\n</form>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/projects/templates/external_service.js.hamlc
// module id = 1533
// module chunks = 18